
import React from 'react';
import MonthlyPlan from './plans/MonthlyPlan';
import AnnualPlan from './plans/AnnualPlan';
import LifetimePlan from './plans/LifetimePlan';

interface PricingPlanProps {
  type: 'monthly' | 'annual' | 'lifetime';
  isProcessing: string | null;
  onSelectPlan: (plan: 'monthly' | 'annual' | 'lifetime') => void;
  popular?: boolean;
}

const PricingPlan: React.FC<PricingPlanProps> = ({ 
  type, 
  isProcessing, 
  onSelectPlan,
  popular = false 
}) => {
  if (type === 'monthly') {
    return <MonthlyPlan isProcessing={isProcessing} onSelectPlan={onSelectPlan} />;
  }
  
  if (type === 'annual') {
    return <AnnualPlan isProcessing={isProcessing} onSelectPlan={onSelectPlan} popular={popular} />;
  }
  
  return <LifetimePlan isProcessing={isProcessing} onSelectPlan={onSelectPlan} />;
};

export default PricingPlan;
